import { Booking } from '@guiker/booking-shared'
import { RentalType } from '@guiker/rental-listing-shared'

import { InquiryUser } from './inquiry-user'

export type VisitSchedule = {
  date: string // YYYY-MM-DD
  timeSlot: {
    morning?: boolean
    afternoon?: boolean
    evening?: boolean
  }
}

export enum ListingInquiryStatus {
  /** @description created by processing multipost inquiry */
  CREATED = 'CREATED',
  /** @description started by confirming created inquiry */
  STARTED = 'STARTED',
  /**
   * @description completed;
   * by completing started inquiry, direct inquiry from listing page, or created from office-webapp
   * */
  COMPLETED = 'COMPLETED',
}

export enum InquiryQualificationStatus {
  PROCESSING = 'PROCESSING',
  QUALIFIED = 'QUALIFIED',
  DISQUALIFIED = 'DISQUALIFIED',
  DROPPED = 'DROPPED',
}

export enum ListingInquirySource {
  MULTIPOSTING = 'MULTIPOSTING',
  ORGANIC = 'ORGANIC',
  OFFICE_LEASING_ASSOCIATE = 'OFFICE_LEASING_ASSOCIATE',
  SPLITSPOT = 'SPLITSPOT',
}

export type ListingInquiry = {
  id?: string
  user: InquiryUser
  isBookingNotificationEnabled?: boolean
  visitSchedules: VisitSchedule[]
  moveInDate?: string
  message: string
  listingId: string
  rentalType?: RentalType
  rentalOptionId?: string
  conversationId?: string
  bookingId?: string
  status: ListingInquiryStatus
  source: ListingInquirySource
  booking?: Booking
  converted?: boolean
  meta?: {
    multipostInquiryId?: string
    channel?: string
    parser?: string
  }
  qualification: {
    status: InquiryQualificationStatus
    sessionId?: string
    note?: string
    isAutomated?: boolean
    criteria?: Partial<{
      roomCount: string
      budget: number
      hasPet: boolean
      needsParking: boolean
      moveInDate: string
      creditScore: string
      visitSchedule: string
      contactMethod: string
    }>
  }
}
